import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import * as React from 'react'
import { useState } from 'react'

import { ReactComponent as SearchIco } from '../../../../Assets/search.svg'
import { RenderButton } from '../../../atoms/Button/RenderButton'
import TextButton from '../../../atoms/Button/Text/Button'
import TextButtonWithIcon from '../../../atoms/Button/Text/ButtonWithIcon'
import Paragraph from '../../../atoms/Paragraph'
import NavComponent from '../../../molecules/NavBarComponent'

interface Props {
  content?: any
}
const MobileMenu = ({ content }: Props) => {
  const [isOpenSubmenu, setIsOpenSubmenu] = useState(false)
  const [subMenu, setSubMenu] = useState([])
  const [lastItem, setLastItem] = useState(null)
  const [parent, setParent] = useState('')
  const [query, setQuery] = useState('')
  const [openIndex, setOpenIndex] = useState(null)
  const handleSubMenu = (submenulist, lastItem, parentItem) => {
    setSubMenu(submenulist)
    setLastItem(lastItem)
    setIsOpenSubmenu(true)
    setParent(parentItem)
    setOpenIndex(null)
  }
  const closeNavSuper = () => {
    setIsOpenSubmenu(false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    window.location.href = `/search-results?query=${encodeURIComponent(query)}`
  }

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div
      data-testid="mobilemenu"
      className="absolute left-0 z-50 flex max-h-[calc(100vh-7rem)] w-full flex-col rounded border bg-neutral-10 shadow-lg"
    >
      <div className="relative overflow-y-scroll">
        <div>
          <ul>
            <li className="border-b border-b-neutral-50 px-24 py-16">
              <form onSubmit={handleSubmit}>
                <div className="group flex w-full justify-center rounded-lg border border-neutral-50 hover:border-violet-300">
                  <input
                    type="text"
                    aria-label="Search Text Input"
                    className="pr-50 w-full flex-1 bg-white/20 p-16 text-lg text-neutral-90 outline-none transition-colors duration-300 group-focus:border-violet-300"
                    placeholder="Search..."
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  <button
                    disabled={query.length < 3}
                    type="submit"
                    aria-label="search-button-with-icon"
                    className="cursor-pointer items-center p-5"
                  >
                    <SearchIco />
                  </button>
                </div>
              </form>
            </li>
            {/* 2nd level navigation */}
            {content?.fields?.navigationSubSection?.fields?.menus.map((menuitem, index) => {
              const submenulist =
                menuitem?.fields?.menusDropdown &&
                menuitem?.fields?.menusDropdown.slice(0, menuitem?.fields?.menusDropdown.length - 1)
              const lastItem =
                menuitem?.fields?.menusDropdown &&
                menuitem?.fields?.menusDropdown[menuitem?.fields?.menusDropdown.length - 1]

              return (
                <li key={`menuItems-${index}`}>
                  {!isOpenSubmenu && (
                    <div className="cursor-pointer">
                      <NavComponent
                        name={menuitem?.fields?.groupName}
                        link={menuitem?.fields?.externelLink}
                        variant="Navmobile"
                        fontColor="text-black"
                        display={true}
                        onClick={() => handleSubMenu(submenulist, lastItem, menuitem?.fields?.groupName)}
                      />
                    </div>
                  )}
                </li>
              )
            })}

            {/* SUbmenu */}
            {isOpenSubmenu && (
              <div className={`flex h-full w-full bg-neutral-10`}>
                <div className="relative w-full bg-neutral-10 pb-32">
                  <div
                    className="w-full cursor-pointer border-b border-neutral-50 p-24"
                    onClick={() => closeNavSuper()}
                  >
                    <TextButtonWithIcon
                      variant="dark"
                      name={parent}
                      classes="textGray"
                      iconPosition="start"
                      arrowDirection="left"
                      buttonType="submit"
                    />
                  </div>
                  <ul>
                    {subMenu.map((menuDropdownitem, index) => (
                      <li
                        key={`dropdownMenu-${index}`}
                        className={`mobileSubMenu ${openIndex === index ? 'open' : ''}`}
                      >
                        <NavComponent
                          name={menuDropdownitem?.fields?.menuName}
                          link={menuDropdownitem?.fields?.externelLink}
                          variant="Navmobile"
                          fontColor="text-black"
                          display={true}
                          arrowDirection="down"
                          onClick={() => {
                            handleToggle(index)
                          }}
                        />
                        {menuDropdownitem?.fields?.menuDecription && (
                          <ul className="submenuContaner border-b border-b-neutral-50 px-24">
                            <li className="px-16 py-16">
                              <Paragraph
                                content={documentToHtmlString(menuDropdownitem?.fields?.menuDecription)}
                                classes="flex items-start text-base textlink"
                              />
                            </li>
                          </ul>
                        )}
                      </li>
                    ))}
                    <li className="px-24 py-16">
                      <div className="list flex flex-col items-start">
                        <NavComponent
                          name={lastItem?.fields?.menuName}
                          link={lastItem?.fields?.externelLink}
                          variant="LinkArrow"
                          fontColor="text-black"
                          classes="mb-8"
                        />
                      </div>
                    </li>
                    <li className="py-16 pl-32">
                      <Paragraph
                        content={documentToHtmlString(lastItem?.fields?.menuDecription)}
                        classes="flex items-start text-base textlink"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {/* 1st level navigation */}
            {content?.fields?.navigationSection?.fields?.menus.map((item, index) => (
              <li key={`list-${index}`} className="px-24 py-16">
                <TextButton
                  variant="dark"
                  fontColor="text-black"
                  name={item?.fields?.groupName}
                  classes="text-neutral-100 hover:underline"
                  link={item?.fields?.externelLink}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="z-50 flex w-full justify-center border-t border-t-neutral-50 bg-neutral-10 p-24">
        <div className="registerBtnMobile mr-12">
          <RenderButton item={content?.fields?.navigationSection?.fields?.register} />
        </div>
        <div className="loginBtnMobile">
          <RenderButton item={content?.fields?.navigationSection?.fields?.login} />
        </div>
      </div>
    </div>
  )
}
export default MobileMenu
